"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Address = _interopRequireDefault(require("./Address/Address"));

var _Ambassador = _interopRequireDefault(require("./Ambassador/Ambassador"));

var _Content = _interopRequireDefault(require("./Content/Content"));

var _DiscoveryMethod = _interopRequireDefault(require("./DiscoveryMethod/DiscoveryMethod"));

var _Donation = _interopRequireDefault(require("./Donation/Donation"));

var _Education = _interopRequireDefault(require("./Education/Education"));

var _Fieldset = _interopRequireDefault(require("./Fieldset/Fieldset"));

var _Header = _interopRequireDefault(require("./Header/Header"));

var _HeightWeight = _interopRequireDefault(require("./HeightWeight/HeightWeight"));

var _Occupation = _interopRequireDefault(require("./Occupation/Occupation"));

var _PhoneNumber = _interopRequireDefault(require("./PhoneNumber/PhoneNumber"));

var _MarketingPreferences = _interopRequireDefault(require("./MarketingPreferences/MarketingPreferences"));

var _MedicalHistory = _interopRequireDefault(require("./MedicalHistory/MedicalHistory"));

var _PersonalDetails = _interopRequireDefault(require("./PersonalDetails/PersonalDetails"));

var _PersonCategory = _interopRequireDefault(require("./PersonCategory/PersonCategory"));

var _PreQualifiers = _interopRequireDefault(require("./PreQualifiers/PreQualifiers"));

var _MotivationForJoining = _interopRequireDefault(require("./MotivationForJoining/MotivationForJoining"));

var _ReasonForDonating = _interopRequireDefault(require("./ReasonForDonating/ReasonForDonating"));

var _ListWithOther = _interopRequireDefault(require("./ListWithOther/ListWithOther"));

var _types = require("../types");

var _componentConfigs = require("./config/componentConfigs");

var _componentDefinitionTypes = require("./config/componentDefinitionTypes");

var _flowRuntime = _interopRequireDefault(require("flow-runtime"));

// eslint-disable-next-line import/no-cycle
var AddressDefinition = _flowRuntime["default"].tdz(function () {
  return _componentDefinitionTypes.AddressDefinition;
});

var AmbassadorDefinition = _flowRuntime["default"].tdz(function () {
  return _componentDefinitionTypes.AmbassadorDefinition;
});

var ContentDefinition = _flowRuntime["default"].tdz(function () {
  return _componentDefinitionTypes.ContentDefinition;
});

var DiscoveryMethodDefinition = _flowRuntime["default"].tdz(function () {
  return _componentDefinitionTypes.DiscoveryMethodDefinition;
});

var DonationDefinition = _flowRuntime["default"].tdz(function () {
  return _componentDefinitionTypes.DonationDefinition;
});

var EducationDefinition = _flowRuntime["default"].tdz(function () {
  return _componentDefinitionTypes.EducationDefinition;
});

var FieldsetDefinition = _flowRuntime["default"].tdz(function () {
  return _componentDefinitionTypes.FieldsetDefinition;
});

var HeaderDefinition = _flowRuntime["default"].tdz(function () {
  return _componentDefinitionTypes.HeaderDefinition;
});

var HeightWeightDefinition = _flowRuntime["default"].tdz(function () {
  return _componentDefinitionTypes.HeightWeightDefinition;
});

var MarketingPreferencesDefinition = _flowRuntime["default"].tdz(function () {
  return _componentDefinitionTypes.MarketingPreferencesDefinition;
});

var MedicalHistoryDefinition = _flowRuntime["default"].tdz(function () {
  return _componentDefinitionTypes.MedicalHistoryDefinition;
});

var OccupationDefinition = _flowRuntime["default"].tdz(function () {
  return _componentDefinitionTypes.OccupationDefinition;
});

var PersonalDetailsDefinition = _flowRuntime["default"].tdz(function () {
  return _componentDefinitionTypes.PersonalDetailsDefinition;
});

var PersonCategoryDefinition = _flowRuntime["default"].tdz(function () {
  return _componentDefinitionTypes.PersonCategoryDefinition;
});

var PhoneNumberDefinition = _flowRuntime["default"].tdz(function () {
  return _componentDefinitionTypes.PhoneNumberDefinition;
});

var PreQualifiersDefinition = _flowRuntime["default"].tdz(function () {
  return _componentDefinitionTypes.PreQualifiersDefinition;
});

var ReasonForDonatingDefinition = _flowRuntime["default"].tdz(function () {
  return _componentDefinitionTypes.ReasonForDonatingDefinition;
});

var ListWithOtherDefinition = _flowRuntime["default"].tdz(function () {
  return _componentDefinitionTypes.ListWithOtherDefinition;
});

var MotivationForJoiningDefinition = _flowRuntime["default"].tdz(function () {
  return _componentDefinitionTypes.MotivationForJoiningDefinition;
});

var ComponentElementDefinition = _flowRuntime["default"].tdz(function () {
  return _types.ComponentElementDefinition;
});

var Props = _flowRuntime["default"].type("Props", _flowRuntime["default"].object(_flowRuntime["default"].property("component", _flowRuntime["default"].ref(ComponentElementDefinition)), _flowRuntime["default"].property("queryParams", _flowRuntime["default"].object(), true)));

var FormComponent = function FormComponent(_arg) {
  var component = _arg.component,
      queryParams = _arg.queryParams;

  switch (component.type) {
    case _componentConfigs.addressConfig.type:
      {
        return /*#__PURE__*/_react["default"].createElement(_Address["default"], {
          key: component.key,
          address: component
        });
      }

    case _componentConfigs.ambassadorConfig.type:
      {
        return /*#__PURE__*/_react["default"].createElement(_Ambassador["default"], {
          key: component.key,
          component: component
        });
      }

    case _componentConfigs.contentConfig.type:
      {
        return /*#__PURE__*/_react["default"].createElement(_Content["default"], {
          key: component.key,
          content: component
        });
      }

    case _componentConfigs.discoveryMethodConfig.type:
      {
        return /*#__PURE__*/_react["default"].createElement(_DiscoveryMethod["default"], {
          key: component.key,
          discoveryMethod: component,
          queryParams: queryParams
        });
      }

    case _componentConfigs.donationConfig.type:
      {
        return /*#__PURE__*/_react["default"].createElement(_Donation["default"], {
          key: component.key,
          donation: component,
          queryParams: queryParams
        });
      }

    case _componentConfigs.educationConfig.type:
      {
        return /*#__PURE__*/_react["default"].createElement(_Education["default"], {
          key: component.key,
          component: component
        });
      }

    case _componentConfigs.fieldsetConfig.type:
      {
        return /*#__PURE__*/_react["default"].createElement(_Fieldset["default"], {
          key: component.key,
          fieldset: component
        });
      }

    case _componentConfigs.headerConfig.type:
      {
        return /*#__PURE__*/_react["default"].createElement(_Header["default"], {
          key: component.key,
          header: component
        });
      }

    case _componentConfigs.heightWeightConfig.type:
      {
        return /*#__PURE__*/_react["default"].createElement(_HeightWeight["default"], {
          key: component.key,
          heightWeight: component
        });
      }

    case _componentConfigs.listWithOtherConfig.type:
      {
        return /*#__PURE__*/_react["default"].createElement(_ListWithOther["default"], {
          key: component.key,
          component: component
        });
      }

    case _componentConfigs.marketingPreferencesConfig.type:
      {
        return /*#__PURE__*/_react["default"].createElement(_MarketingPreferences["default"], {
          key: component.key,
          marketingPreferences: component
        });
      }

    case _componentConfigs.medicalHistoryConfig.type:
      {
        return /*#__PURE__*/_react["default"].createElement(_MedicalHistory["default"], {
          key: component.key,
          medicalHistory: component
        });
      }

    case _componentConfigs.occupationConfig.type:
      {
        return /*#__PURE__*/_react["default"].createElement(_Occupation["default"], {
          key: component.key,
          occupation: component
        });
      }

    case _componentConfigs.personalDetailsConfig.type:
      {
        return /*#__PURE__*/_react["default"].createElement(_PersonalDetails["default"], {
          key: component.key,
          personalDetails: component
        });
      }

    case _componentConfigs.personCategoryConfig.type:
      {
        return /*#__PURE__*/_react["default"].createElement(_PersonCategory["default"], {
          key: component.key,
          personCategory: component,
          queryParams: queryParams
        });
      }

    case _componentConfigs.phoneNumberConfig.type:
      {
        return /*#__PURE__*/_react["default"].createElement(_PhoneNumber["default"], {
          key: component.key,
          phoneNumber: component
        });
      }

    case _componentConfigs.preQualifiersConfig.type:
      {
        return /*#__PURE__*/_react["default"].createElement(_PreQualifiers["default"], {
          key: component.key,
          preQualifiers: component
        });
      }

    case _componentConfigs.motivationForJoiningConfig.type:
      {
        return /*#__PURE__*/_react["default"].createElement(_MotivationForJoining["default"], {
          key: component.key,
          motivationForJoining: component,
          queryParams: queryParams
        });
      }

    case _componentConfigs.reasonForDonatingConfig.type:
      {
        return /*#__PURE__*/_react["default"].createElement(_ReasonForDonating["default"], {
          key: component.key,
          reasonForDonating: component,
          queryParams: queryParams
        });
      }

    default:
      // eslint-disable-next-line no-console
      console.warn('Unknown component type', component.type);
      return null;
  }
};

FormComponent.defaultProps = {
  queryParams: null
};
var _default = FormComponent;
exports["default"] = _default;